<template>
  <div>
    <!-- desktop version -->
    <div class="speakol-help-parent">
      <div class="relative">
        <vs-icon @mouseover="iconMouseOver" @mouseleave="iconMouseLeave" class="" icon-pack="speakol"
          icon="speakol-help-3" round></vs-icon>
      </div>

      <div @mouseover="tooltipMouseOver" @mouseleave="tooltipMouseLeave" v-if="showTooltip"
        class="customize-tooltip-with-action absolute">
        <div class="triangle-left"></div>
        <p>{{tooltipText}}</p>

        <a class="font-medium" :href="tooltipRedirect" target="_blank">{{tooltipAction}}</a>
      </div>
    </div>
    <!-- desktop version -->

    <!-- mobile version -->
    <div class="speakol-help-parent-mobile-version">
      <div class="relative">
        <vs-icon id="helpIcon" @click="iconClick" class="" icon-pack="speakol" icon="speakol-help-3" round></vs-icon>
      </div>
      <div id="tooltipBox" v-if="showTooltip" class="customize-tooltip-with-action absolute">
        <div class="triangle-left"></div>
        <p>{{tooltipText}}</p>

        <a @click="linkClick" :href="tooltipRedirect" target="_blank">{{tooltipAction}}</a>
      </div>
    </div>
    <!-- mobile version -->
  </div>
</template>

<script>
export default {
  name: 'speakol-tooltip',

  props: {
    tooltipText: {
      type: String
    },
    tooltipAction: {
      type: String
    },
    tooltipRedirect: {
      type: String
    }
  },

  data () {
    return {
      showTooltip: false
    }
  },

  mounted () {
    if (window.innerWidth <= 768) {
      window.addEventListener('click', (e) => {
        if (!e.target.closest('#helpIcon') && !e.target.closest('.customize-tooltip-with-action')) {
          this.showTooltip = false

        }
      })
    }
  },

  methods: {
    iconMouseOver () {
      this.showTooltip = true
    },

    iconMouseLeave () {
      this.timer = setTimeout(() => {
        this.showTooltip = false
      }, 100)
    },

    tooltipMouseLeave () {
      this.showTooltip = false
    },

    tooltipMouseOver () {
      this.showTooltip = true
      clearTimeout(this.timer)
    },

    iconClick () {
      this.showTooltip = !this.showTooltip
    },

    linkClick () {
      this.showTooltip = false
    }
  }


}

</script>

<style lang="scss" scoped>
  .speakol-help-parent {
    position: relative;
    top: 7px;

    i {
      color: var(--metalicGray);
      font-size: 16px !important;
      margin-left: 8px;
    }

    .customize-tooltip-with-action {
      background-color: #363636;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      color: white;
      padding: 16px;
      left: 40px;
      top: -3px;
      width: 375px;
      z-index: 1;

      .triangle-left {
        width: 0;
        height: 0;
        border-top: 7px solid transparent;
        border-right: 7px solid #363636;
        border-bottom: 7px solid transparent;
        position: absolute;
        left: -5px;
        top: 5px;
      }

      p {
        font-size: 13px;
        font-weight: 300;
        line-height: 21px;
        margin-bottom: 16px;
      }

      a {
        font-size: 13px;
        font-weight: 500;
      }
    }
  }

  .speakol-help-parent-mobile-version {
    position: relative;
    top: 7px;
    display: none;

    i {
      color: var(--metalicGray);
      font-size: 16px !important;
      margin-left: 8px;
    }

    .customize-tooltip-with-action {
      background-color: #363636;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
      color: white;
      padding: 16px;
      right: -15px;
      top: 30px;
      width: 220px;
      z-index: 9991;

      .triangle-left {
        width: 0;
        height: 0;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid #363636;
        position: absolute;
        right: 15px;
        top: -6px;
      }

      p {
        font-size: 13px;
        font-weight: 300;
        margin-bottom: 16px;
      }

      a {
        font-size: 13px;
        font-weight: 500;
      }
    }
  }

  @media (max-width: 768px) {
    .speakol-help-parent-mobile-version {
      display: block;
    }

    .speakol-help-parent {
      display: none;
    }
  }

</style>
